import { useCallback } from 'react'
import type { ComponentProps } from 'react'
import { useReserveNavigate, useSendClickEvent } from '~/navigation'
import { useCalendarQueryStatus, useReservable, useReserveCondition } from '~/stores/calendar/state'
import { Button } from '~/ui'

export function ToReservation({
  isLoading,
  className,
  color,
  size,
}: {
  isLoading?: boolean
  className?: string
  color: ComponentProps<typeof Button>['color']
  size: ComponentProps<typeof Button>['size']
}) {
  const { disabled, ...props } = useToReservationSelection()
  return (
    <div className={className}>
      <Button spread={true} size={size} color={color} disabled={disabled || isLoading} {...props}>
        {isLoading ? 'loading...' : '予約へすすむ'}
      </Button>
    </div>
  )
}

function useToReservationSelection() {
  const value = useReserveCondition()
  const reservable = useReservable()
  const status = useCalendarQueryStatus()
  const navigate = useReserveNavigate()

  const sendClickEvent = useSendClickEvent()
  const onClick = useCallback(() => {
    if (value !== undefined) {
      sendClickEvent({
        inventoryCalendar: 'toReserve',
        click_event: 'newReservationFlow/inventoryCalendar/toReserve',
      })

      navigate({
        type: 'selectDateTime',
        ...value,
      })
    }
  }, [navigate, value, sendClickEvent])

  if (status !== 'success') {
    return { disabled: true, onClick: nop }
  }
  if (!reservable) {
    return { disabled: true, onClick: nop }
  }
  return { disabled: false, onClick }
}

function nop() {}
